/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Map_View_3d_DescInputs */

const en_ui_map_view_3d_desc = /** @type {(inputs: Ui_Map_View_3d_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terrain from Mapterhorn`)
};

const de_ui_map_view_3d_desc = /** @type {(inputs: Ui_Map_View_3d_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelände von Mapterhorn`)
};

/**
* | output |
* | --- |
* | "Terrain from Mapterhorn" |
*
* @param {Ui_Map_View_3d_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_map_view_3d_desc = /** @type {((inputs?: Ui_Map_View_3d_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Map_View_3d_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_map_view_3d_desc(inputs)
	return de_ui_map_view_3d_desc(inputs)
});